import { SITE_ID_TO_RECREATE } from 'src/js/constants/common';

const getSiteIdToRecreateTemplate = () => {
  const parsedUrl = new URL(window.location.href);

  return parsedUrl.searchParams.get(SITE_ID_TO_RECREATE);
};

export default getSiteIdToRecreateTemplate;
